import React, { useEffect, useRef } from 'react';

/**
 * Lightweight Leaflet map loaded from CDN (no extra npm install required).
 */
const RouteMap = ({ depot, stops }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !depot?.latitude) return;

    const init = () => {
      const L = window.L;
      if (!L) return;
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
      const map = L.map(containerRef.current).setView(
        [Number(depot.latitude), Number(depot.longitude)],
        11
      );
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap',
      }).addTo(map);

      L.marker([Number(depot.latitude), Number(depot.longitude)])
        .addTo(map)
        .bindPopup(depot.name ? `Depot: ${depot.name}` : 'Depot');

      const sorted = [...(stops || [])].sort((a, b) => a.sequence - b.sequence);
      sorted.forEach((s) => {
        L.marker([Number(s.latitude), Number(s.longitude)])
          .addTo(map)
          .bindPopup(
            `#${s.sequence} ${s.label || ''}<br/>${(s.address_text || '').replace(/,/g, ', ')}`
          );
      });

      const routePts = [
        [Number(depot.latitude), Number(depot.longitude)],
        ...sorted.map((s) => [Number(s.latitude), Number(s.longitude)]),
      ];
      if (routePts.length >= 2) {
        L.polyline(routePts, { color: '#2563eb', weight: 3, opacity: 0.7 }).addTo(map);
        map.fitBounds(L.latLngBounds(routePts), { padding: [30, 30] });
      }
      mapRef.current = map;
    };

    if (window.L) {
      init();
      return () => {
        if (mapRef.current) {
          mapRef.current.remove();
          mapRef.current = null;
        }
      };
    }

    if (!document.getElementById('leaflet-css')) {
      const link = document.createElement('link');
      link.id = 'leaflet-css';
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(link);
    }
    if (!document.getElementById('leaflet-js')) {
      const script = document.createElement('script');
      script.id = 'leaflet-js';
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.onload = init;
      document.body.appendChild(script);
    } else {
      init();
    }

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [depot, stops]);

  if (!depot?.latitude) {
    return <p className="empty-state">Depot has no coordinates.</p>;
  }

  return (
    <div
      ref={containerRef}
      style={{ height: '320px', width: '100%', borderRadius: '8px', marginBottom: '1rem' }}
    />
  );
};

export default RouteMap;
